import React from "react";

const LoaderHome = () => {
  return (
    <section className="loaderhouse">
      <div>
        <div>
          <span className="one h66"></span>
          <span className="two h33"></span>
        </div>
      </div>

      <div>
        <div>
          <span className="one h11"></span>
        </div>
      </div>

      <div>
        <div>
          <span className="two h22"></span>
        </div>
      </div>
      <div>
        <div>{/* <span className="one h44"></span> */}</div>
      </div>
    </section>
  );
};

export default LoaderHome;
